import axios, { InternalAxiosRequestConfig } from 'axios';

import { getClient } from '@sentry/react';

export const axiosSentryIntegration = () => {
  const originalRequestUse = axios.interceptors.request.use;
  const originalResponseUse = axios.interceptors.response.use;

  axios.interceptors.request.use = function (onSuccess, onError, config) {
    return originalRequestUse.call(
      this,
      (...args) => {
        try {
          return onSuccess?.(...args) as InternalAxiosRequestConfig<any> | Promise<InternalAxiosRequestConfig<any>>;
        } catch (error) {
          console.error('Error in request onSuccess interceptor', error);
          getClient()?.captureException(error, {});
          return error as InternalAxiosRequestConfig<any> | Promise<InternalAxiosRequestConfig<any>>;
        }
      },
      (error) => {
        try {
          getClient()?.captureException(error, {});
          return onError?.(error) ?? error;
        } catch (onErrorError: unknown) {
          console.error('Error in request onError interceptor', onErrorError);
          getClient()?.captureException(onErrorError, {});
          return onErrorError;
        }
      },
      config,
    );
  };
  axios.interceptors.response.use = function (onSuccess, onError, config) {
    return originalResponseUse.call(
      this,
      async (value) => {
        try {
          return (await onSuccess?.(value)) ?? value;
        } catch (error) {
          console.error('Error in response onSuccess interceptor', error);
          getClient()?.captureException(error, {});
          return value;
        }
      },
      (error) => {
        try {
          getClient()?.captureException(error, {});
          return onError?.(error) ?? error;
        } catch (exErr) {
          console.error('Error in request onError interceptor');
          getClient()?.captureException(exErr, {});
          return error;
        }
      },
      config,
    );
  };
};
